export default __webpack_public_path__ + "static/media/02.dd0c8901.jfif";